import React, { useState } from 'react';
import cx from 'classnames';

import { IconButton } from '@material-ui/core';
import EditIcon from '@material-ui/icons/Edit';
import CloseIcon from '@material-ui/icons/Close';

import Zone from 'components/shared/Zone';
import Stack from 'components/shared/Stack';

import LeadDetails from './LeadDetails';
import CustomerDetails from './CustomerDetails';
import LeadSummary from './LeadSummary';

type Props = {
  className?: string;
};

const LeftPanel = ({ className }: Props) => {
  const [isEditingLead, setIsEditingLead] = useState(false);

  const toggleEditMode = (editing: boolean) => () => {
    setIsEditingLead(editing);
  };

  return (
    <Stack className={cx('grid-panel', className)}>
      <Zone
        heading={
          <div className="horizontal-space">
            lead details
            {isEditingLead ? (
              <IconButton
                className="no-padding"
                aria-label="cancel"
                onClick={toggleEditMode(false)}
              >
                <CloseIcon />
              </IconButton>
            ) : (
              <IconButton className="no-padding" aria-label="edit" onClick={toggleEditMode(true)}>
                <EditIcon />
              </IconButton>
            )}
          </div>
        }
      >
        <LeadDetails editMode={isEditingLead} onEditComplete={toggleEditMode(false)} />
      </Zone>
      <Zone heading="company details">
        <CustomerDetails />
      </Zone>
      <Zone heading="lead summary">
        <LeadSummary />
      </Zone>
    </Stack>
  );
};

export default LeftPanel;
